import React from "react"
import styles from "./LoadingButton.module.scss"
import Button, { IButtonProps } from "../Button/Button"
import Spinner from "../Spinner/Spinner"
import cn from "classnames"
import { testId as defaultTestId } from "../../utility/tests/testId/common"

export interface LoadingButtonProps extends IButtonProps {
    loading?: boolean
    dropdownArrow?: boolean
    testId?: string
}

const LoadingButton: React.FC<LoadingButtonProps> = props => {
    const {
        loading = false,
        dropdownArrow = false,
        testId = defaultTestId.loadingButton,
        children,
        variant = "primary",
        className,
        ...buttonProps
    } = props

    return (
        <Button
            {...buttonProps}
            variant={variant}
            className={cn(styles.loadingButton, loading && styles.loadingButton_isLoading, className)}
            disabled={loading ? true : buttonProps.disabled}
            testId={testId}
        >
            <div className={styles.loadingButton__content}>{children}</div>
            <div className={styles.loadingButton__spinnerContainer}>
                <Spinner
                    className={cn(
                        styles.loadingButton__spinner,
                        variant === "light" || variant === "link" || variant?.startsWith("outline-")
                            ? styles.loadingButton__spinner_dark
                            : undefined
                    )}
                />
            </div>
        </Button>
    )
}

export default LoadingButton
